// extracted by css-extract-rspack-plugin
export default {"animatedIcon":"animatedIcon-n58Sox"};